import(/* webpackMode: "eager" */ "/home/runner/work/cc-admin/cc-admin/src/app/global-error.tsx");
